import script from "./CartProductsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CartProductsTab.vue?vue&type=script&setup=true&lang=js"

import "./CartProductsTab.vue?vue&type=style&index=0&id=36ffb189&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ffb189"]])

export default __exports__